import React from "react";
import "./Beneficiaries.css";

/* ================= SVG ICONS ================= */
const HeartPlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);

const HeartDonateIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
  </svg>
);

/* ================= COMPONENT ================= */
function Beneficiaries() {
  // Exactly 25 Beneficiaries Data
  var beneficiariesList = [
     { name: "Rajamani", img: "../images/SK_07588.jpg", featured: false },
  { name: "Eenestine Lacroix", img: "../images/SK_07594.jpg", featured: false },
  { name: "Chellama", img: "../images/new0.jpg", featured: false },
  { name: "Kamala", img: "../images/SK_07608.jpg", featured: false },
  { name: "Krishinaveni", img: "../images/SK_07611.jpg", featured: false },
  { name: "Caroline", img: "../images/SK_07613.jpg", featured: false },
  { name: "Lakshmi", img: "../images/SK_07615.jpg", featured: true }, // Featured member
  { name: "Usha", img: "../images/SK_07619.jpg", featured: false },
  { name: "Bakkiyam", img: "../images/SK_07622.jpg", featured: false },
  { name: "Dhanalakshmi", img: "../images/SK_07624.jpg", featured: false },
  { name: "Kamatchi", img: "../images/SK_07628.jpg", featured: false },

  { name: "Govindamale", img: "../images/SK_07655.jpg", featured: false },
  { name: "Saroja", img: "../images/SK_07661.jpg", featured: false },
  { name: "Periyanayaki", img: "../images/SK_07694.jpg", featured: false },
  { name: "Lakshmi", img: "../images/SK_07698.jpg", featured: false },
  { name: "Ranganathan", img: "../images/SK_07702.jpg", featured: false },
  { name: "Lakshmi", img: "../images/SK_07705.jpg", featured: false },
  { name: "Chandra", img: "../images/SK_07707.jpg", featured: false },
  { name: "Josphine", img: "../images/SK_07712.jpg", featured: false },
  { name: "Porameshwari", img: "../images/SK_07715.jpg", featured: false },
  { name: "Martha", img: "../images/SK_07719.jpg", featured: false }
  ];

  return (
    <div className="beneficiaries-page-wrapper">
      
      {/* ================= HERO BANNER ================= */}
      <section className="beneficiaries-hero"  style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title"  className="hero-title"
  style={{
    textAlign: "center"
  }}>Our Beneficiaries</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Beneficiaries</span>
          </div>
        </div>
      </section>

      {/* ================= MAIN GRID SECTION ================= */}
      <section className="beneficiaries-section">
        <div className="beneficiaries-container">
          
          {/* Header Title matching reference image layout */}
          <div className="section-header">
            <span className="section-badge">OUR IMPACT</span>
            <h2 className="section-title">Meet Our Beneficiaries</h2>
            <p className="section-subtitle">
              Empowering lives through dedicated support, steady opportunities, and consistent care.
            </p>
          </div>

          {/* 25 Person Grid */}
          <div className="beneficiaries-grid">
            {beneficiariesList.map(function (person, index) {
              return (
                <div key={index} className={"beneficiary-card " + (person.featured ? "active-card" : "")}>
                  
                  {/* Portrait Image */}
                  <div className="card-img-wrapper">
                    <img src={person.img} alt={person.name} className="beneficiary-img" loading="lazy" />
                  </div>

                  {/* Overlaid Info Box matching reference image */}
                  <div className="card-info-box">
                    
                    {/* Floating Top-Left Orange Badge */}
                    <div className="floating-badge">
                      <HeartPlusIcon />
                    </div>

                    <h3 className="beneficiary-name">{person.name}</h3>
                    <span className="beneficiary-date">{person.date}</span>

                    {/* Decorative dots visible in the featured/hover state */}
                    <div className="card-dots">
                      <span className="dot"></span>
                      <span className="dot"></span>
                      <span className="dot"></span>
                    </div>

                  </div>

                </div>
              );
            })}
          </div>

        </div>
      </section>

      {/* ================= DONATE CTA FOOTER ================= */}
      <section className="donate-footer-cta">
        <div className="cta-container center">
          <h2 className="cta-heading">Help Us Support More Lives Today</h2>
          <p className="cta-desc">Your contribution creates an immediate, lasting impact in our community.</p>
          <a href="/DonateNow" className="btn-donate-massive">
            <HeartDonateIcon />
            <span>Donate Now</span>
          </a>
        </div>
      </section>

    </div>
  );
}

export default Beneficiaries;